import App from "../../../vendor_core/core/src/App";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { ConfigurationTypes } from '../../../vendor_core/core/src/const/ConfigurationTypes';
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import ConfigManager from '../../../vendor_core/core/src/managers/ConfigManager';
import IRulesScenesCount from '../../../vendor_core/core/src/contracts/IRulesScenesCount';
import AutoplayModel from '../../../vendor_core/core/src/model/AutoplayModel';
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import UIController from '../../../vendor_core/core/src/ui/UIController';
import Layout from '../../../vendor_core/core/src/utils/Layout';
import Locale from "../../../vendor_core/core/src/utils/Locale";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import SwitchButton from "../../../vendor_core/core/src/views/components/SwitchButton";
import TextField from '../../../vendor_core/core/src/views/components/TextField';
import { MoneyField } from '../../../vendor_core/core/src/views/MoneyField';
import SceneView from '../../../vendor_core/core/src/views/SceneView';
import IVendorClientConfigRequestData from '../../../vendor_core/server/requests/contracts/IVendorClientConfigRequestData';
import Settings from "../../../vendor_core/src/base/ui/Settings";
import Utils from '../../../vendor_core/core/src/utils/Utils';
import IRulesScenes from '../../../vendor_core/core/src/managers/contracts/configurations/settings/IRulesScenes';

export default class BBSettings extends Settings {
    protected _minFontSizePortrait: number | string = null;
    protected _minFontSizeLandscape: number | string = null;
    constructor() {
        super();
    }

    get minFontSize(): number | string {
        if (Layout.isLandscape()) {
            return this.minFontSizeLandscape
        } else {
            return this.minFontSizePortrait
        }
    }

    get minFontSizePortrait(): number | string {
        return this._minFontSizePortrait
    }

    set minFontSizePortrait(value: number | string) {
        this._minFontSizePortrait = value
    }
    get minFontSizeLandscape(): number | string {
        return this._minFontSizeLandscape
    }

    set minFontSizeLandscape(value: number | string) {
        this._minFontSizeLandscape = value
    }

    protected showAudioSettings() {
        SoundController.playSound(SoundVars.BUTTON_CLICK, false, undefined, false);
        // console.log('Play sound?');
        if (this.currentSettingsPage == "sound") {
            return;
        }
        this.currentSettingsPage = "sound";
        this.scene = this.contentLayer.setScene("sound");
        this.applyFontSize();
        let musicToggle = this.scene.buttons.get("sound") as SwitchButton;
        let soundToggle = this.scene.buttons.get("music") as SwitchButton;
        let turboToggle = this.scene.buttons.get("turbo") as SwitchButton;
        if (turboToggle) {
            turboToggle.switch(GameModel.turboSpin);
            turboToggle.on(PointerEvents.DOWN, () => {

                turboToggle.toggle();
                CommandManager.execute(Commands.TOGGLE_TURBO_SPIN);
                App.dispatcher.emit(GameEvents.TOGGLE_TURBO_SPIN)
            });
        }
        soundToggle.switch(SoundController.isEffectsEnabled);
        musicToggle.switch(SoundController.isMusicEnabled);

        soundToggle.on(PointerEvents.DOWN, () => {
            soundToggle.toggle();
            CommandManager.execute(Commands.TOGGLE_SOUND_FX, soundToggle.isSelected());
            // SoundController.toggleEffects(soundToggle.isSelected());
            // SoundController.masterVolume = soundToggle.isSelected() ? 1 : 0;

            // this.saveSettings();
        });

        musicToggle.on(PointerEvents.DOWN, () => {
            musicToggle.toggle();
            CommandManager.execute(Commands.TOGGLE_MUSIC, musicToggle.isSelected());
            // SoundController.toggleMusic(musicToggle.isSelected());
            // SoundController.masterVolume = musicToggle.isSelected() ? 1 : 0;
            // this.saveSettings();
        });

        this.update();
    }

    // TO DO! - Find the way to calculate min font size without setScene() !!!
    protected findMinFontSize(): number {
        let config = ConfigManager.getConfig(ConfigurationTypes.SETTINGS);
        // debugger
        let result = 0;
        let scenes = config.scenesForCalculatingMinFontSize;
        let bgText = this.findBiggestText();
        let sceneName: string = "";

        if (config.biggestTextScene) {
            sceneName = config.biggestTextScene;
        } else {
            sceneName = this.contentLayer.findSceneNameContainsBound(bgText.sceneTextField);
        }

        if (sceneName.length > 0) {
            let scene = this.contentLayer.setScene(sceneName, { textFieldApplyBound: false });
            if (scene.sceneTextFields.has(bgText.sceneTextField)) {
                this.fillTexts(scene, false, true);
                let tx = scene.sceneTextFields.get(bgText.sceneTextField) as TextField;
                result = Number(tx.style.fontSize);
            }
            console.warn(
                `[SETTINGS] -> Biggest text in current setting rules is in textField: <${bgText.sceneTextField}>,
                you can prevent this search (this search down the performance) if you place this text field name in SettingsConfig like <"biggestTextTextField">.
                This text field is located in Scene: <${sceneName}>,
                you can prevent this search (this search down the performance) if you place this scene name in SettingsConfig like <"biggestTextScene">`,
            );
        } else {
            for (let index = 0; index < scenes.length; index++) {
                let scene = this.contentLayer.setScene(scenes[index], { textFieldApplyBound: false });
                if (scene.sceneTextFields.has(bgText.sceneTextField)) {
                    this.fillTexts(scene, false, true);
                    let tx = scene.sceneTextFields.get(bgText.sceneTextField) as TextField;
                    result = Number(tx.style.fontSize);
                    break;
                }
            }
        }

        return result
    }

    public show(page?: string): void {
        // let time = new Date().getTime();
        this.calculateMinFontSize();
        super.show(page);
        // console.log(new Date().getTime() - time);

    }

    protected calculateMinFontSize(): void {
        if (!this.minFontSize) {
            let fontSize = this.findMinFontSize();
            Layout.isLandscape() ? this.minFontSizeLandscape = fontSize : this.minFontSizePortrait = fontSize;
        }
    }

    public showAutoPlay() {
        this.currentSettingsPage = "autoplay";
        this.update();
        SoundController.playSound(SoundVars.BUTTON_CLICK, false, undefined, false);
        this.showAutoplayPage();
    }

    protected showAutoplayPage() {
        let scene = ViewManager.getLayer("MenusContent").setScene("autoplay");
        let autospins = scene.buttonGroups.get("spinsCount");
        let lossLimit = scene.buttonGroups.get("lossAmount");
        let singleWinLimit = scene.buttonGroups.get("winAmount");
        let clearBtn = scene.buttons.get("clear");
        let playBtn = scene.buttons.get("play");


        // Auto-play - Autoplay is not supported [Lithuania]
        let isFeatureAllowed = !ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable;

        ////////////////
        // AUTO SPIN COUNT
        ////////////////
        let autospinValues = AutoplayModel.spinPresets;
        if (autospinValues.length == 0) {
            autospinValues = [5, 10, 25, 50, 100];
        }
        autospins.replaceButtonTexts((value, index) =>
            value.replace("{0}", `${autospinValues[autospinValues.length - 1 - index]}`)
        );

        // Loop through the values to select the current one
        autospins.getChildren().forEach((child: SwitchButton) => {
            child.setEnabled(isFeatureAllowed);
            child.switch(
                parseFloat(child.getValue()) == AutoplayModel.getAutoSpinNum()
            );
        });

        ////////////////
        // LOSS LIMIT
        ////////////////
        let lossLimits = AutoplayModel.lossLimits;
        if (lossLimits.length == 0) {
            lossLimits = [2, 5, 10, 20];
        }
        lossLimit.replaceButtonTexts((value, index) => {
            // let bet = BetModel.formatCurrency(BetModel.totalBet);
            return value.replace("{0}", `${lossLimits[lossLimits.length - 1 - index]}x`)
        });
        // Loop through the values to select the current one
        lossLimit.getChildren().forEach((child: SwitchButton) => {
            child.setEnabled(isFeatureAllowed);
            let buttonValue = Number(child.getValue().split("x")[0]) * BetModel.totalBet;
            child.switch(buttonValue == AutoplayModel.getLossLimit());
        });

        ////////////////
        // WIN LIMIT
        ////////////////
        let singleWinLimits = AutoplayModel.singleWinLimits;
        if (singleWinLimits.length == 0) {
            singleWinLimits = [2, 5, 10, 20];
        }
        singleWinLimit.replaceButtonTexts((value, index) => {
            // let bet = BetModel.formatCurrency(BetModel.totalBet);
            return value.replace("{0}", `${singleWinLimits[singleWinLimits.length - 1 - index]}x`)
        });
        // Loop through the values to select the current one
        singleWinLimit.getChildren().forEach((child: SwitchButton) => {
            child.setEnabled(isFeatureAllowed);
            let buttonValue =
                Number(child.getValue().split("x")[0]) * BetModel.totalBet;
            child.switch(buttonValue == AutoplayModel.getWinLimit());
        });

        let updatePlayButton = () => {
            let enabled =
                isFeatureAllowed &&
                autospins.isSelected() &&
                lossLimit.isSelected() &&
                singleWinLimit.isSelected();
            playBtn.setEnabled(enabled);
        };

        clearBtn.setEnabled(isFeatureAllowed);

        const saveSettings = () => {
            CommandManager.execute(Commands.SAVE_SETTINGS);
        };

        lossLimit.onSelect((value) => {
            SoundController.playSound(SoundVars.BUTTON_CLICK);
            value = Number(value.split("x")[0]) * BetModel.totalBet;
            AutoplayModel.setLossLimit(Number(value));
            updatePlayButton();
            saveSettings();
        });

        singleWinLimit.onSelect((value) => {
            SoundController.playSound(SoundVars.BUTTON_CLICK);
            value = Number(value.split("x")[0]) * BetModel.totalBet;
            AutoplayModel.setWinLimit(Number(value));
            updatePlayButton();
            saveSettings();
        });

        autospins.onSelect((value) => {
            SoundController.playSound(SoundVars.BUTTON_CLICK);
            value = Number(value.split("x")[0]);
            AutoplayModel.setAutoSpin(value);
            updatePlayButton();
            saveSettings();
        });

        clearBtn.on(PointerEvents.DOWN, () => {
            SoundController.playSound(SoundVars.BUTTON_CLICK);
            lossLimit.deselect();
            singleWinLimit.deselect();
            autospins.deselect();
            AutoplayModel.setAutoSpin(0);
            AutoplayModel.setWinLimit(0);
            AutoplayModel.setLossLimit(0);
            // StopAutoplayCommand();
            updatePlayButton();
            saveSettings();
        });

        playBtn.off(PointerEvents.DOWN);
        playBtn.on(PointerEvents.DOWN, () => {
            SoundController.playSound(SoundVars.BUTTON_CLICK);
            CommandManager.execute(Commands.START_AUTOPLAY)
            UIController.toggleComponent("settings");
        });

        updatePlayButton();
    }
    protected showBetOptions() {
        SoundController.playSound(SoundVars.BUTTON_CLICK, false, undefined, false);
        if (this.currentSettingsPage == "bet") {
            return;
        }
        this.update();
        this.currentSettingsPage = "bet";
        this.scene = this.contentLayer.setScene("bet");
        this.applyFontSize();


        let j = 0;
        let validBetsOptions = ConfigManager.getConfig(ConfigurationTypes.BET).getBetOptions();
        while (this.scene.buttons.has("betAmount~" + (j + 1))) {
            let value = validBetsOptions[j];
            this.setBet(value, j);
            j++
        }
    }
    protected setBet = (value: number, j: number): void => {
        let btn = this.scene.buttons.get(
            "betAmount~" + (j + 1)
        ) as SwitchButton;
        // console.log("Bet model, coin size index: ", BetModel.coinSizeIndex)
        // console.log("Bet model, coin size: ", BetModel.coinSize)
        btn.switch(BetModel.coinSizeIndex == j);
        let betField = this.scene.sceneMoneyFields.get(
            "betAmount~" + (j + 1)
        ) as MoneyField;
        if (!value) {
            btn.visible = false;
            betField.visible = false;
        } else {
            betField.value = value as number;
            this.assignInterraction(
                [Commands.SET_BET, Commands.SAVE_SETTINGS],
                btn,
                SoundVars.BUTTON_CLICK,
                BetModel.creditValues.indexOf(value)
            );
        }
    }
    protected showPayTable() {
        SoundController.playSound(SoundVars.BUTTON_CLICK, false, undefined, false);
        const scenes = ConfigManager.getConfig(ConfigurationTypes.SETTINGS).rulesScenes;
        this.update();
        this.payTablePage = 1;
        this.currentSettingsPage = scenes.paytable;
        // remove feature bye rules from game rules if feature will be deactivated by jurisdiction
        let scenesCount = this.parseScenesCount(scenes);

        this.paytablePageScenes = [];
        this.createPayTablePagesArray(scenes.paytable, scenesCount.paytable);
        this.createPayTablePagesArray(scenes.gameRules, scenesCount.gameRules);
        this.createPayTablePagesArray(scenes.featureRules, scenesCount.featureRules);
        this.createPayTablePagesArray(scenes.autoplayRules, scenesCount.autoplayRules);
        // this.paytablePageScenes = this.paytablePageScenes.filter(page => page != 'gamerules~4');
        this.scene = this.contentLayer.setScene(
            this.paytablePageScenes[this.payTablePage - 1],
            { textFieldApplyBound: false }
        );
        this.leftArrow.visible = false;
        this.rightArrow.visible = true;

        this.forceCalculatedBounds(this.scene)
        this.fillTexts();
        this.calculateWins();
    }

    protected parseScenesCount(scenes: IRulesScenes): IRulesScenesCount {
        let scenesCount: IRulesScenesCount = {};
        Object.entries(scenes).forEach(([key, value]) => {
            scenesCount[key] = this.contentLayer.getScenesTypeCount(value);
        })

        let result = this.disableRulesPages(scenesCount);

        return result

    }

    protected disableRulesPages(scenesCount: IRulesScenesCount): IRulesScenesCount {

        let result = Utils.deepClone(scenesCount);

        if (
            ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.disableBuyFeature
        ) {
            result.gameRules -= 1;
        }
        if (
            ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.hideGameRules
        ) {
            result.gameRules = 0;
        }
        if (
            ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable
        ) {
            result.autoplayRules = 0;
        }

        return result
    }

    protected applyFontSize(scene: SceneView = this.scene): void {
        if (scene.sceneTextFields) {
            const textFields = ConfigManager.getConfig(ConfigurationTypes.SETTINGS).applyMinFontSizeTextFields;
            textFields.forEach(tf => {
                if (scene.sceneTextFields.has(tf)) {
                    this.applyMinFontSize(scene.sceneTextFields.get(tf) as TextField);
                }
            })
        }
    }

    protected applyMinFontSize(textField: TextField): void {
        textField.style.fontSize = this.minFontSize;
        textField.fixFontSize = this.minFontSize;
    }

    protected setText(scene: SceneView = this.scene, textFieldName: string, body: string): void {
        let textField = scene.sceneTextFields.get(textFieldName) as TextField;
        textField.text = body;
    }

    protected fillTexts(scene: SceneView = this.scene, applyFontSize: boolean = true, applyText: boolean = true) {
        const rules = ConfigManager.getConfig(ConfigurationTypes.SETTINGS).rulesData;
        let textFieldName = null;
        let body = "";


        // FREESPIN rules
        if (scene.sceneTextFields) {
            for (let index = 0; index < rules.length; index++) {
                const rule = rules[index];
                if (scene.sceneTextFields.has(rule.sceneTextField)) {
                    textFieldName = rule.sceneTextField;
                    body = this.getBodyString(rule.name, rule.rulesDimensions);
                    break;
                }

            }
        }

        if (textFieldName === null && body.length === 0 && applyFontSize) {
            this.applyFontSize(scene)
        }

        if (textFieldName && body.length > 0 && applyText) {
            if (applyFontSize) {
                this.setFixedFontSize(scene, textFieldName)
            }
            this.setText(scene, textFieldName, body)
        }
    }

    protected setFixedFontSize(scene: SceneView, textFieldName: string): void {
        let textField = scene.sceneTextFields.get(textFieldName) as TextField;
        textField.fixFontSize = this.minFontSize;
    }

    protected findBiggestText(): { name?: string, rules?: [number, number], sceneTextField: string } {
        let config = ConfigManager.getConfig(ConfigurationTypes.SETTINGS);
        let result = null;

        if (config.biggestTextTextField) {
            result = {
                sceneTextField: config.biggestTextTextField
            }
        } else {
            let rules = config.rulesData;
            let maxLength = 0
            rules.forEach(obj => {
                let str = this.getBodyString(obj.name, obj.rulesDimensions);
                if (maxLength < str.length) {
                    maxLength = str.length;
                    result = obj
                }
            })

            console.warn(
                `[SETTINGS] -> Biggest text in current setting rules is in textField: <${result.sceneTextField}>,
                you can prevent this search (this search down the performance) if you place this text field name in SettingsConfig like <"biggestTextTextField">`,
            );
        }


        return result
    }

    protected getBodyString = (key: string, [start, end]: number[]) => {
        let body = "";
        for (let index = start; index <= end; index++) {
            const element = `${key}${index}`;
            body += "● " + Locale.getString(element) + "\n\n";
        }

        return body
    }

    protected switchPayTables(direction: string, pagesCount: number) {
        if (direction === "previous" && this.payTablePage > 1) {
            this.payTablePage--;
        }
        if (direction === "next" && this.payTablePage < pagesCount) {
            this.payTablePage++;
        }
        this.leftArrow.visible = !(this.payTablePage === 1);
        this.rightArrow.visible = !(this.payTablePage === pagesCount);
        this.scene = this.contentLayer.setScene(
            this.paytablePageScenes[this.payTablePage - 1],
            { textFieldApplyBound: false }
        );

        this.forceCalculatedBounds(this.scene);
        this.fillTexts();

        if (this.scene.buttons && this.scene.buttons.has("history")) {
            if (
                !ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.disableShowHistory
            ) {
                this.scene.buttons.get("history").on(PointerEvents.DOWN, (e) => {
                    CommandManager.execute(Commands.REQUEST_HISTORY),
                        SoundController.playSound(SoundVars.BUTTON_CLICK);
                    e.stopPropagation();
                })
            } else {
                this.scene.buttons.get("history").visible = false;
            }
        }

        this.calculateWins();
    }

    protected forceCalculatedBounds = (scene: SceneView) => {
        if (scene.sceneTextFields) {
            let forceCalculatedBound = ConfigManager.getConfig(ConfigurationTypes.SETTINGS).forceCalculateBound;
            if (forceCalculatedBound.length > 0) {
                scene.sceneTextFields.forEach(txf => {
                    if (forceCalculatedBound.includes((txf as TextField).bound.id)) {
                        (txf as TextField).applyBound();
                    }
                })
            }
        }
    }

    protected calculateWins() {
        if (this.scene.sceneMoneyFields && GameModel.gameConfig.pt_map) {
            Object.keys(GameModel.gameConfig.pt_map).forEach((key) => {
                if (this.scene.sceneMoneyFields.has(key)) {
                    this.scene.sceneMoneyFields.get(key).centerVertical();
                    this.scene.sceneMoneyFields.get(key).value =
                        Math.round(BetModel.totalBet / 20 * GameModel.gameConfig.pt_map[key]);
                }
            });
        }
    }
}
